import React, { useCallback } from "react";
import Particles from "react-particles";
import { loadFull } from "tsparticles";

import "./Particles/particle1.css";

const ParticlesBg = (props) => {
  const { option } = props;
  const particlesInit = useCallback(async (engine) => {
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    await console.log("particles loaded");
  }, []);

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      loaded={particlesLoaded}
      options={option}
      style={{ maxWidth: "100% !important", overflow: "scroll" }}
      className="particle1"
    />
  );
};

export default ParticlesBg;
